<template>
  <!-- 客户信息插件 -->
  <div>
    <div class="ddcheckitem">
      <div class="ddxznum">
        <div class="ddnum">
          <div class="leftnum">选择数量</div>
          <van-stepper v-model="yknum" :disable-input="isstepperInput" input-width="40px" button-size="32px"
            @plus="addYk(true)" @minus="addYk(false)" @change="onChangeNum" min="0" max="999" />
        </div>
      </div>
      <div class="yklist" v-if="yknum > 0">
        <div class="ykitem" v-for="(item,index) in ykListData" :key="index">
          <div class="left">
            <div class="cleryk" v-if="item.contacts==''">
              <span>乘车人{{index+1}}</span>
            </div>
            <div class="cleryk" v-else @click="cutYk(index)">
              <span>乘车人{{index+1}}</span>
              <van-icon name="delete-o" />
            </div>
            <div class="ykxx" @click="openYkpopup(item,index)">
              <span v-if="item.contacts==''">点击补全乘客信息</span>
              <div v-else>
                <div class="xxitem">{{item.contacts}} {{item.telephone}}</div>
                <!-- <div class="xxitem">手机号 {{item.telephone}}</div>
                <div class="xxitem">证件号 {{item.IDCard}}</div> -->
              </div>
            </div>
          </div>
          <!-- <div class="right" @click="openYkpopup1(index)">
            <span>选择</span>
          </div> -->
        </div>
      </div>
    </div>
    <!--新增或者编辑-->
    <van-popup v-model="ykpopupshow" style="margin-bottom: 0;" round position="bottom" :style="{ height: '60%' }">
      <div class="popup-box">
        <div class="titile">
          <span class="an"></span>
          <span>{{titlename}}</span>
          <span class="an" @click="closePopup">取消</span>
        </div>
        <van-form @submit="addYkxx">
          <van-field v-model="ykxx.namenew" clearable name="姓名" label="姓名" placeholder="必填,输入真实姓名" />
          <van-field v-model="ykxx.telnew" clearable label="手机号" type="tel" placeholder="必填,输入联系人手机号" />
          <van-field readonly label="证件类型" :value="ykxx.card_type" placeholder="请选择证件类型" @click="showPickercard = true" />
          <van-popup v-model="showPickercard" round position="bottom">
            <van-picker title="证件类型" show-toolbar :columns="columns" @cancel="showPickercard = false"
              @confirm="onConfirmCard" />
          </van-popup>
          <van-field v-model="ykxx.idcardnew" clearable label="证件号" placeholder="必填,输入证件号" />
          <van-field readonly label="出生日期" :value="ykxx.birthday" placeholder="请选择出生年月" @click="showPicker = true" />
          <van-popup v-model="showPicker" round position="bottom">
            <van-datetime-picker v-model="currentDate" @confirm="onConfirm" type="date" title="选择年月日"
              :min-date="minDate" :max-date="maxDate" />
          </van-popup>
          <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit">确认</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
    <!--已有游客列表-->
    <van-popup v-model="ykpopupshow1" style="margin-bottom: 0;" round position="bottom"
      :style="{ height: '80%',width:'100%' }">
      <div class="popup-box" style="height:calc(100% - 25px) ; overflow: hidden;">
        <div class="titile">
          <span class="an" @click="addUser">新增</span>
          <span>选择人员</span>
          <span class="an" @click="closePopup1">取消</span>
        </div>
        <div class="gdp-m">
          <div v-if="userlist.length < 1" style="padding: 30px 0;text-align: center;color: #b6b6b6;">暂无游客信息</div>
          <van-cell v-else v-for="(item,index) in userlist" :key="index" :title="item.contacts + ' ' + item.telephone"
            :label="item.card_type_text +'  '+ item.IDCard" clickable @click="checkUser($event,item)">
            <template #right-icon>
              <div style="width: 80px;display: flex;align-items: center;justify-content: space-between;">
                <p style="width: 30px; display: flex;align-items: center;" @click="openYkpopup(item,-1)">
                  <van-icon name="edit" size="20" color="#00aaff" />
                </p>
                <p style="width: 30px; display: flex;align-items: center;" @click="deledteuser(item)">
                  <van-icon name="delete-o" size="20" color="#ff5500" />
                </p>
              </div>
            </template>
          </van-cell>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import * as util from "@/utils/network";
  import {
    Toast,
  } from "vant";
  export default {
    props: {
      // 证件类型
      columns: {
        type: Array,
      },
    },
    data() {
      return {
        yknum: 0, // 当前商品数量
        ykListData: [], // 选中的游客信息集合
        selectid: -1, // 当前选中的游客下标
        titlename: "新增游客",
        ykxx: { // 新增的游客信息
          namenew: "",
          telnew: "",
          idcardnew: "",
          birthday: '',
          card_type: ""
        },
        ykxxS: {}, // 当前选中的游客
        selectnum: 0, //已填写数量
        ykpopupshow: false, // 新增或者编辑游客 弹出
        ykpopupshow1: false, // 选择游客 弹出
        userlist: [], // 游客列表
        isTc: false, //新增-false还是编辑-true
        showPicker: false, // 显示证件类型下拉框
        isstepper: false, // 数量是否可点击
        isstepperInput: false, // 计步器输入框是否可点击
        traveldate: '请选择出行日期',
        order_type: '10',
        skulistprice: true,
        minDate: new Date(1900, 0, 1),
        maxDate: new Date(),
        currentDate: new Date(),
        selectTimedata: [],
        showPickercard:false
      };
    },
    created() {},
    mounted() {
      this.defuaultListNum();

    },
    watch: {},
    methods: {
      /***证件类型 */
      onConfirm(value) {
        let dqdate = this.formatDate(value); // 返回日期格式
        this.showPicker = false;
        this.currentDate = new Date(value);
        this.ykxx.birthday = dqdate
      },
      // 日期格式
      formatDate(date) {
        return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
      },
      /***********************游客列表********************************* */
      // 初始化游客数量
      defuaultListNum() {
        let that = this;
        let ny = that.yknum;
        if (that.order_type == "20") {
          ny = 1;
        }
        that.ykListData = [];
        for (var i = 1; i <= ny; i++) {
          let item = {
            contacts: "",
            telephone: "",
            IDCard: "",
            card_type: "",
            birthday: ''
          };
          that.ykListData.unshift(item);
        }
      },
      // 删除游客
      deledteuser(item) {
        var url = "/addons/litestore/api.player/del";
        let that = this;
        //这里直接调用网络接口
        util.post(
          url, {
            id: item.id
          },
          function() {
            that.getUserList(); // 刷新列表
          }
        );
      },
      //新增游客
      addUser() {
        this.ykpopupshow = true;
        this.isTc = false;
        this.titlename = "新增游客";
        this.ykxx = { // 新增游客信息
          namenew: "",
          telnew: "",
          idcardnew: "",
          card_type: "",
          birthday: ''
        };
      },
      // 打开添加游客信息
      openYkpopup(item, i) {
        this.selectid = i;
        let that = this;
        let tt = item;
        let isedit = true;
        if (!tt.contacts && !tt.telephone) {
          isedit = false
        }
        // 编辑的情况下再去赋值
        if (isedit) {
          that.titlename = "编辑人员";
          that.ykxxS = tt;
          that.ykxx.namenew = tt.contacts;
          that.ykxx.telnew = tt.telephone;
          that.ykxx.idcardnew = tt.IDCard;
          that.ykxx.birthday = tt.birthday;
          that.ykxx.card_type = that.visitorAndPriceVal(tt.card_type, 'val');
          that.isTc = true;
          if (!tt.id) {
            that.userlist.forEach(list => {
              let isedit = list.IDCard == tt.IDCard && list.telephone == tt.telephone && list.contacts == tt
                .contacts;
              if (isedit) {
                that.ykxxS = list;
              }
            })
          }
        } else {
          that.titlename = "新增人员";
          that.isTc = false;
          this.ykxx = { // 新增游客信息
            namenew: "",
            telnew: "",
            idcardnew: "",
            birthday: '',
            card_type: "",
          };
        }
        that.ykpopupshow = true;
      },
      // 外部删除游客
      cutYk(i) {
        let that = this;
        let item = {
          contacts: "",
          telephone: "",
          IDCard: "",
          birthday: '',
          card_type: ""
        };
        that.ykListData.splice(i, 1, item);
      },
      // 点击补全客户信息
      openYkpopup1(i) {
        this.ykpopupshow1 = true;
        this.selectid = i;
        this.getUserList();
      },
      // 请求获取游客列表
      getUserList() {
        var url = "/addons/litestore/api.player/index";
        let that = this;
        //这里直接调用网络接口
        util.post(url, {}, function(result) {
          that.userlist = result.data.list;
        });
      },
      //游客列表中选择游客
      checkUser(e, item) {
        // 阻止点击编辑和删除
        if (
          e.target._prevClass == "van-icon van-icon-edit" ||
          e.target._prevClass == "van-icon van-icon-delete-o"
        ) {
          return;
        }
        let that = this;
        that.ykxxS = item; // 当前选中的游客
        let idata = { // 提取所需的数据
          contacts: item.contacts,
          telephone: item.telephone,
          IDCard: item.IDCard,
          birthday: item.birthday,
          card_type: that.visitorAndPriceVal(item.card_type, 'val'),
          skuid: that.skuid
        };
        that.ykListData.splice(that.selectid, 1, idata); // 替换到指定下标
        this.$emit("YkSubmit", that.ykListData, that.skuid);
        that.ykpopupshow1 = false;
        that.isTc = false;
      },
      // 添加/编辑客户信息
      addYkxx() {
        let that = this;
        let msg = "";
        if (that.ykxx.namenew == "") {
          msg = "请填写姓名";
        } else if (that.ykxx.telnew == "") {
          msg = "请填写手机号";
        } else if (that.cardMust && !that.ykxx.card_type) {
          msg = "请选择证件类型";
        } else if (that.ykxx.idcardnew == "") {
          msg = "请填写证件号";
        } else if (that.ykxx.birthday == "") {
          msg = "请选择出生年月日";
        }

        if (msg != "") {
          Toast({
            message: msg
          });
          return;
        } else {
          let idata = {
            contacts: that.ykxx.namenew,
            telephone: that.ykxx.telnew,
            IDCard: that.ykxx.idcardnew,
            card_type: that.ykxx.card_type,
            birthday: that.ykxx.birthday,
          };
          that.ykxxS.contacts = that.ykxx.namenew;
          that.ykxxS.telephone = that.ykxx.telnew;
          that.ykxxS.IDCard = that.ykxx.idcardnew;
          that.ykxxS.card_type = that.visitorAndPriceVal(that.ykxx.card_type, 'text');
          that.ykxxS.birthday = that.ykxx.birthday;

          // that.openYkE(that.ykxxS, idata); // 编辑还是新增游客
          // let {
          //   telnew,
          //   namenew,
          //   idcardnew,
          //   birthday
          // } = that.ykxx;
          // let obj = {
          //   contacts: namenew,
          //   telephone: telnew,
          //   IDCard: idcardnew,
          //   birthday,
          // }
          // this.selectTimedata.push(obj)
          // console.log(this.selectTimedata, '123456')
          that.ykListData.splice(that.selectid, 1, idata);
          this.$emit('selectTime', that.ykListData);
          // that.ykxx = {
          //   namenew: "",
          //   telnew: "",
          //   idcardnew: "",
          //   birthday: '',
          // };
          that.ykpopupshow = false;
        }
      },
      visitorAndPriceVal(val, type) {
        let columns = this.columns;
        let value = val + '';
        columns.forEach(item => {
          if (type == 'text') {
            if (item.text == value) {
              val = item.value;
            }
          }
          if (type == 'val') {
            if (item.value == value) {
              val = item.text;
            }
          }
        })
        return val
      },
      // 计数器数量改变时触发
      onChangeNum(v) {
        if (!this.skulistprice) {
          return false
        }
        //let skulistprice = parseFloat(this.skulistprice);
        let skulistprice = this.skulistprice;
        let obj = {
          num: v,
          id: this.skuid,
          skulistprice,
          groupid: this.groupid
        }
        this.$emit("onChangeNum", obj);
      },
      // 点击计数器时触发
      addYk(isadd) {
        if (!this.skulistprice) {
          return false
        }
        let that = this;
        // 一人多证时
        if (that.order_type == "20") {
          if (this.yknum > 0) {
            return;
          } else {
            that.ykListData = [];
          }
        }

        if (isadd) {
          this.yknum = ++this.yknum;
        } else {
          this.yknum = --this.yknum;
        }
        if (isadd) {
          let item = {
            contacts: "",
            telephone: "",
            card_type: '',
            IDCard: "",
            birthday: "",
          };
          that.ykListData.unshift(item); // 增加一个游客
        } else {
          that.ykListData.splice(0, 1); // 删除一个游客
        }
        // this.$emit("YkSubmit", that.ykListData, that.skuid);
        //this.$emit('selectTime', that.ykListData);
      },
      // 编辑-添加弹出
      closePopup() {
        this.ykpopupshow = false;
      },
      // 游客弹出
      closePopup1() {
        //this.isTc = false;
        this.ykpopupshow1 = false;
      },
      /***证件类型 */
      onConfirmCard(value) {
        this.showPickercard = false;
        this.ykxx.card_type = value.text
      },
    }
  };
</script>

<style lang="less">
  /deep/ .van-popup--bottom {
    margin-bottom: 0 !important;
  }

  .popup-box {
    overflow-x: hidden;
    overflow-y: scroll;

    .van-cell {
      padding: 0 !important;
      line-height: 50px;
    }
  }

  .popup-box::-webkit-scrollbar {
    display: none;
  }

  .gdp-m {
    height: calc(100% - 52px);
    overflow-x: hidden;
  }

  .gdp-m::-webkit-scrollbar {
    display: none;
  }

  .ykusers {
    padding: 10px 0;
  }

  .ykusers+.ykusers {
    border-top: 1px solid #e5e5e5;
  }
</style>

<style lang="less" scoped>
  // 弹出框
  .popup-box {
    padding: 15px;

    .titile {
      padding: 5px 0;
      display: flex;
      justify-content: space-between;

      span {
        display: block;
        font-size: 18px;
        font-weight: 600;
        color: #2c3e50;
      }

      .an {
        color: #00aaff;
        font-size: 15px;
      }
    }

    .items {
      padding: 15px 0;

      .item {
        display: flex;
        padding: 12px 0;
        font-size: 14px;

        span {
          font-size: 12px;
          color: #959595;
        }
      }
    }
  }

  // 数量
  .ddxznum {
    padding: 0 15px;
    background-color: #fff;

    .ddnum {
      padding: 10px 0;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;

      .leftnum {
        font-size: 14px;
        font-size: #333;
        font-weight: 600;
      }
    }
  }

  // 游客选择
  .yklist {
    .ykitem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding: 10px 15px;

      .left {
        display: flex;
        align-items: center;

        .cleryk {
          text-align: center;
          color: #909090;
          display: flex;
          align-items: center;

          span {
            margin-bottom: 0;
            display: block;
            margin-right: 8px;
          }
        }

        .ykxx {
          padding: 0 15px;

          span {
            color: #00aaff;
          }

          .xxitem {
            padding: 2px 0;
          }
        }
      }
    }

    .ykitem+.ykitem {
      border-top: 1px solid #dedede;
    }

    .right {
      font-size: 13px;
      color: #00aaff;
    }
  }

  .stock {
    display: flex;
    justify-content: space-between;
    padding: 10px 16px;

    span {
      position: relative;
    }
  }

  .date {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;

    .date-time {
      color: #909090;
    }
  }
</style>
